import React from 'react';
import cn from 'clsx';

import BarRatingItem from './bar-rating-item/bar-rating-item';

import styles from './bar-rating.scss';

export interface AverageRating {
  label: string;
  value: number;
}

interface BarRatingProps {
  averageRatings: AverageRating[];
  className?: string;
  heading?: string;
}

function BarRating(props: BarRatingProps) {
  const { averageRatings, className, heading = '' } = props;

  return (
    <div className={cn(styles['container'], `${className || ''} bar-rating`)}>
      {heading && <h5 className={styles['section-heading']}>{heading}</h5>}
      <div className={cn(styles['average-ratings'], 'bar-rating__ratings')}>
        <div
          className={cn(
            styles['average-ratings-section'],
            'bar-rating__ratings-section'
          )}
        >
          {averageRatings.map(averageRating => (
            <BarRatingItem
              averageRating={averageRating}
              key={averageRating.label}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export { BarRatingItem };
export default BarRating;
